import Vue from 'vue'
import Router from 'vue-router'
import turn from '@/components/turn'
import link from '@/components/link'
import award1688 from '@/components/award1688'
import award918 from '@/components/award918'
import hongbao from '@/components/hongbao'
import fifa2026 from '@/components/fifa2026'
import award168 from '@/components/award168'
import entry2 from '@/components/entry2'
import entry from '@/components/entry'
import award18 from '@/components/award18'
import luckyDraw from '@/components/luckyDraw'
import maintenance1688 from '@/components/maintenance1688'
import lottery from '@/components/lottery'//公版
import lotteryHitEgg from '@/components/lottery_hitegg'//公版
import lotteryGasha from '@/components/lottery_gasha'//公版

Vue.use(Router)


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/turn',
      name: 'turn',
      component: turn
    },
    {
      path: '/entry',
      name: 'entry',
      component: entry
    },
    {
      path: '/lottery',
      name: 'lottery',
      component: () => import('@/components/lottery_ichibankuji')
      // component: lottery
    },
    {
      path: '/lottery_ich',
      name: 'Lottery_Ichibankuji',
      component: () => import('@/components/lottery_ichibankuji')
    },
    {
      path: '/lottery_gasha',
      name: 'lotteryGasha',
      component: lotteryGasha
    },
    {
      path: '/lottery_hit_egg',
      name: 'lotteryHitEgg',
      component: lotteryHitEgg
    },
    {
      path: '/entry2',
      name: 'entry2',
      component: entry2
    },
    {
      path: '/hongbao',
      name: 'hongbao',
      component: hongbao,
      meta: {title: 'HongBao'}
    },
    {
      path: '/fifa2026',
      name: 'fifa2026',
      component: fifa2026,
      meta: { title: '世界盃冠軍競猜' }
    },
    {
      path: '/luckyDraw',
      name: 'luckyDraw',
      component: luckyDraw,
      meta: {title: 'LuckyDraw'}
    },
    {
      path: '/award1688',
      name: 'award1688',
      component: award1688
    },
    {
      path: '/link',
      name: 'link',
      component: link
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js